$(document).ready(function () {
  try {
    $('form').on('submit', function (e) {
      var $recaptcha = $(this).find('.g-recaptcha');
      if ($recaptcha.length && not_robot === false) {
        return false;
      }

      if ($(this).find('.js-form-email').length) {
        var email = $(this).find('.js-form-email').val();
        if (!isValidEmailAddress(email)) {
          $(this).find('.js-form-error').text('').removeClass('is-visible');
          $(this)
            .find('.js-form-error')
            .text('Please enter a valid email address')
            .addClass('is-visible');
          return false;
        } else {
          $(this).find('.js-form-error').removeClass('is-visible');
        }
      }
    });
  } catch (e) {
    Rollbar.error('form-validate js', e);
  }
});

function isValidEmailAddress(emailAddress) {
  var pattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  );
  return pattern.test(emailAddress);
}
